<template>
  <v-row>
    <!-- PRIMERA TABLA -->
    <v-col cols="12" xs="12" sm="12" md="6" lg="6">
      <v-card-title>
        <div>
          <div>
            Articulos
            <v-btn @click="InicializarArticulos" small text class="success darken-1 mx-2"
              >Actualizar</v-btn
            >
          </div>
        </div>

        <v-divider dark class="ma-4" inline></v-divider>

        <div class="d-flex">
          <v-autocomplete v-model="lineaSeleccionada" :items="lineasArticulos" 
          item-text="NOMBRE"
          item-value="NOMBRE"
          label="Filtrar por Linea:"
          return-object
          class="mx-2"
          />
          <v-text-field
            v-model="buscador"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
          />
        </div>
      </v-card-title>

      <v-data-table
        class="elevation-1 grey lighten-2"
        :headers="columnasTabla1"
        :items="filtrarArticulos"
        :search="buscador"
        :loading="cargando"
        :footer-props="{
          'items-per-page-options': [5, 10, 15, 20],
        }"
      >
        <template v-slot:[`item.actionEditar`]="{ item }">
          <v-btn
            @click="AgregarArticulo(item)"
            small
            light
            class="amber lighten-2"
            style=""
          >
            Agregar
          </v-btn>
        </template>
      </v-data-table>
    </v-col>
    <!-- TERMINA LA PRIMERA TABLA -->

    <v-divider vertical style="border-color: rgba(0, 0, 0, 0.42)"></v-divider>

    <!-- SEGUNDA TABLA -->
    <v-col cols="12" xs="12" sm="12" md="6" lg="6">
      <v-card-title class="">
        <span>Articulos Agregados </span>

        <ModalExcel @EXCEL="archivoExcel" />
        <v-divider dark class="ma-4" inline></v-divider>

        <v-text-field
          v-model="buscador2"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        />
      </v-card-title>

      <v-data-table
        class="elevation-1 grey lighten-2"
        :headers="columnasTabla2"
        :items="articulosAgregados"
        :search="buscador2"
      >
        <template v-slot:[`item.AccionCantidad`]="{ item }">
          <v-text-field
            v-model="item.CANTIDAD"
            label="Cantidad"
            type="number"
            min="1"
          />
        </template>

        <template v-slot:[`item.AccionCosto`]="{ item }">
          <v-text-field
            v-model="item.COSTO"
            label="Costo"
            value="0.0"
            prefix="$"
            type="number"
            min="0"
          />
        </template>

        <template v-slot:[`item.AccionQuitar`]="{ item }">
          <v-btn
            @click="QuitarArticulo(item)"
            small
            text
            dark
            class="red darken-1"
          >
            Quitar
          </v-btn>
        </template>
      </v-data-table>
    </v-col>
    <!-- TERMINA SEGUNDA TABLA -->
  </v-row>
</template>

<script>
import ModalExcel from "./Modals/ModalExcel.vue";
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  components: { ModalExcel },
  data() {
    return {
      cargando: false,

      buscador: "",
      buscador2: "",

      articulos: [],
      articulosAgregados: [],
      lineasArticulos:[],
      lineaSeleccionada:[],

      columnasTabla1: [
        { text: "Clave",    value: "CLAVE_MSP", width:'15%'},
        { text: "Articulo", value: "NOMBRE", filterable:false, width:'70%'},
        { text: "Agregar", sortable: false, value: "actionEditar", align: "right",width:'15%'},
      ],
      columnasTabla2: [
        { text: "Clave",    value: "CLAVE_MSP", width:'15%'},
        { text: "Cantidad", sortable: false, value: "AccionCantidad", width: 100 / 5,},
        { text: "Articulo", value: "NOMBRE" },
        { text: "Precio", sortable: false, value: "AccionCosto" },
        { text: "Accion", sortable: false, value: "AccionQuitar", align: "right",},
      ],
    };
  },

  computed: {
    ...mapGetters(["getURLAPI"]),

    filtrarArticulos: function () {
      return this.articulos.filter( (articulo) =>{
        if (this.lineaSeleccionada == null ){
          return articulo
        }else{
          return articulo.LINEA_ARTICULO_ID.toString().match( this.lineaSeleccionada.LINEA_ARTICULO_ID_MSP )
        }
      })
    }
  },

  // ------------------------------------------------------------------------------
  methods: {
    AgregarArticulo(articulo) {
      if (!this.articulosAgregados.includes(articulo)) {
        this.articulosAgregados.push(articulo);
        this.$emit("setArticulos", this.articulosAgregados);
        console.log(this.articulosAgregados);
        console.log(JSON.stringify(this.articulosAgregados));
      }
    },

    // ------------------------------------------------------------------------------
    QuitarArticulo(articulo) {
      articulo.ARCHIVO = "";
      const index = this.articulosAgregados.indexOf(articulo);
      if (index > -1) {
        this.articulosAgregados.splice(index, 1);
        this.$emit("setArticulos", this.articulosAgregados);
      }
      console.log(this.articulosAgregados);
    },

    // ------------------------------------------------------------------------------
    async InicializarArticulos() {
      this.cargando = true;
      this.articulos = [];

      this.articulos = (
        await axios.get(`${this.getURLAPI}/Show/allArticles`)
      ).data;
      this.articulos.forEach((articulo) => {
        articulo.CANTIDAD = 1;
      });

      this.cargando = false;
    },

    archivoExcel(excel) {
      this.$emit("archivoExcel", excel);
    },

    async getLineasComboBox(){
      this.lineasArticulos = (await axios.get(`${this.getURLAPI}/Show/allLinea`)).data
    },

    // log(){
    //   console.log(this.articulosAgregados);
    // },
  },

  created() {
    this.InicializarArticulos();
    this.getLineasComboBox();
  },
};
</script>

<style>

</style>
